import React from "react";

const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="72" height="73" viewBox="0 0 72 73" fill="none" {...props}>
    <path d="M57 12.5H15C11.6863 12.5 9 15.1863 9 18.5V60.5C9 63.8137 11.6863 66.5 15 66.5H57C60.3137 66.5 63 63.8137 63 60.5V18.5C63 15.1863 60.3137 12.5 57 12.5Z" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M48 6.5V18.5" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M24 6.5V18.5" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 30.5H63" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);


export default Calendar;